// 1~4는 MediaError값 그대로 사용
export enum IniErrorCode {
  Aborted = 1,
  Network = 2,
  Decode = 3,
  Unsupport = 4,
  Drm = 90,
  IniInternal = 99,
  // 임의로 에러를 만들어 사용할 때 사용하는 코드
  Custom = 100,
}
